import React from 'react';
import { Hero } from './components/Hero';
import { Testimonials } from './components/Testimonials';
import { PainSection } from './components/PainSection';
import { TomosSection } from './components/TomosSection';
import { BonosSection } from './components/BonosSection';
import { PricingSection } from './components/PricingSection';
import { ComparisonTable } from './components/ComparisonTable';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { CostTable } from './components/CostTable';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
import { TopAnnouncementBar } from './components/TopAnnouncementBar';
import { TrustMarquee } from './components/TrustMarquee';
import { MoreTestimonials } from './components/MoreTestimonials';
export function App() {
  return <div className="min-h-screen bg-graphite text-white font-body selection:bg-electric selection:text-white" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <TopAnnouncementBar data-id="element-2" />
      <TrustMarquee data-id="element-3" />
      <Hero data-id="element-4" />
      <div className="section-divider" data-id="element-5"></div>
      <PainSection data-id="element-6" />
      <div className="section-divider" data-id="element-7"></div>
      <Testimonials data-id="element-8" />
      <div className="section-divider" data-id="element-9"></div>
      <TomosSection data-id="element-10" />
      <div className="section-divider" data-id="element-11"></div>
      <BonosSection data-id="element-12" />
      <div className="section-divider" data-id="element-13"></div>
      <PricingSection data-id="element-14" />
      <div className="section-divider" data-id="element-15"></div>
      <ComparisonTable data-id="element-16" />
      <div className="section-divider" data-id="element-17"></div>
      <MoreTestimonials data-id="element-18" />
      <div className="section-divider" data-id="element-19"></div>
      <GuaranteeSection data-id="element-20" />
      <div className="section-divider" data-id="element-21"></div>
      <FAQSection data-id="element-22" />
      <div className="section-divider" data-id="element-23"></div>
      <CostTable data-id="element-24" />
      <div className="section-divider" data-id="element-25"></div>
      <FinalCTA data-id="element-26" />
      <Footer data-id="element-27" />
    </div>;
}